import Alpine from 'alpinejs';

import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import resize from '@alpinejs/resize';
import validation from 'alpinejs-form-validation';

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(resize);
Alpine.plugin(validation);

Alpine.start();
